module.exports = __webpack_public_path__ + "static/media/resi02.c44abfd1.jpeg";